var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 3.33333L1.99995 3.33333C1.87845 3.33371 1.75936 3.36721 1.65549 3.43024C1.55163 3.49327 1.46692 3.58343 1.41048 3.69103C1.35405 3.79862 1.32802 3.91956 1.33521 4.04085C1.3424 4.16213 1.38253 4.27915 1.45128 4.37932L7.45128 13.046C7.69994 13.4053 8.29861 13.4053 8.54794 13.046L14.5479 4.37933C14.6174 4.27936 14.6581 4.16228 14.6657 4.0408C14.6733 3.91931 14.6474 3.79807 14.5909 3.69025C14.5344 3.58243 14.4495 3.49216 14.3453 3.42923C14.2411 3.3663 14.1217 3.33313 13.9999 3.33333Z",
    fill: "#152745"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.3b9682a1f005597f6023189e189d844e.svg";
export { ForwardRef as ReactComponent };